<!-- TEMPLATE -->
<template>
    <div :class='addressesListClass'>
        <div class='row'>
            <div class='small-12 medium-12 large-12 hd-12 columns dashboard-content'>
                <dean-section-title content='true'>
                  <span slot='title'>
                    <span class='avenir-heavy'>Adressen</span>
                  </span>

                  <dean-section-title-item
                    v-if="canCreatePartnerAddress()"
                    :icon='plusIcon'
                    :content="true"
                    @click.native="sectionRoute('partner.address.add')"
                  >
                      Nieuw
                  </dean-section-title-item>
                </dean-section-title>

                <dean-table
                  :data='addressesData'
                  :columns='columns'
                  :hover="true"
                  @column-click='columnClick'
                  @cell-click="cellClick"
                >
                </dean-table>

                <dean-pagination
                  :current-page='addressesMetaData.pageNumber'
                  :total-items='addressesMetaData.totalResults'
                  :items-per-page='addressesMetaData.itemsPerPage'
                  :select-items-per-page='selectItemsPerPage'
                  :visible-pages='addressesMetaData.visiblePages'
                  @page-changed='paginationChanged'
                  @items-per-page='itemsPerPageChanged'
                >
                </dean-pagination>
            </div>
        </div>
    </div>
</template>

<script lang='ts'>
  // VUE
  import {
    Vue,
    Component,
  } from 'vue-property-decorator';
  import axios from 'axios';
  import deanTableMixin from '@/mixins/deanTableMixin';
  import sideMenuPartnerMixin from '@/mixins/sideMenuPartnerMixin';
  import {mixins} from 'vue-class-component';

  import {
    // SVG
    invoicesIcon,
    // COMPONENTS
    deanTable,
    deanPagination,
    deanInputSelect,
    deanSectionDivider,
    deanSectionTitle,
    deanSectionTitleItem,
    deanSearchField,
    deanIcon,
    plusIcon,
    summeryIcon,
  } from '@deanone/dean-components';

  @Component({
    components: {
      deanPagination,
      deanTable,
      deanInputSelect,
      deanSectionDivider,
      deanSectionTitle,
      deanSectionTitleItem,
      deanSearchField,
      invoicesIcon,
      deanIcon,
      plusIcon,
      summeryIcon,
    },
  })
  export default class List extends mixins(deanTableMixin, sideMenuPartnerMixin) {

    public showSomething: boolean = false;
    public plusIcon: object = plusIcon;
    public data: object[] = [];

    // COMPUTED
    get addressesListClass() {
      let value = 'address-summary';
      if (this.showSomething) {
        value += ' no-scroll-container';
      }
      return value;
    }

    get addressesMetaData() {
      return this.pageMeta;
    }

    get addressesData() {
      return this.data;
    }

    public meta: object = {};

    public columns: any = {
      label: {
        content: 'label',
        align: 'left',
        sort: true,
        dql: 'label',
      },
      attention: {
        content: 't.a.v.',
        align: 'left',
        sort: true,
        dql: 'attention',
      },
      street: {
        content: 'straat',
        align: 'left',
        sort: true,
        dql: 'street',
      },
      houseNumber: {
        content: 'huisnummer + toevoeging',
        align: 'left',
        sort: true,
        dql: 'city',
      },
      postalCode: {
        content: 'postcode',
        align: 'left',
        sort: true,
        dql: 'postalCode',
      },
      city: {
        content: 'plaats',
        align: 'left',
        sort: true,
        dql: 'city',
      },
    };

    public tableName(): string {
      return 'partner-addresses';
    }

    public cellClick(target: { cell: object, row: { id: string, personId: string }, column: string }) {
      this.$router.push({
        name: 'partner.address.edit',
        params: {addressId: target.row.id, pid: target.row.personId},
      });
    }

    // METHODS
    public loadList(data: any) {
      this.$store.dispatch('setLoadOverlay', true);

      const url = '/-/trade/api/partner.addresses.list';

      axios.post(url, {
        id: this.$route.params.pid,
      })
        .then((response) => {
          const partnerAddressesData: any[] = [];
          for (const item of response.data) {
            const row = {
              id: item.id,
              // tslint:disable-next-line:max-line-length
              personId: this.$route.params.pid,
              label: item.label,
              attention: item.attention,
              street: item.street,
              houseNumber: item.houseNumber + (
                  item.houseNumberExtension ?
                      '-' + item.houseNumberExtension :
                      ''
              ),
              postalCode: item.postalCode,
              city: item.city,
            };
            partnerAddressesData.push(row);
          }

          this.data = partnerAddressesData;
          this.updateMeta(response.data.meta);
        }).then(
        // Resolve promise response/error
        (response) => {
          this.$store.dispatch('setLoadOverlay', false);
        },
        (error) => {
          this.$store.dispatch('setLoadOverlay', false);
        },
      );
    }

    public canCreatePartnerAddress(): boolean {
      if (this.$store.getters.getUser.privileges.includes('create-address')) {
        return true;
      }

      return false;
    }

    public created() {
      this.setDefaultSort('label');
      this.loadList(this.pageMeta);
      this.buildSideMenuPartner();
    }
  }
</script>

<!-- STYLE -->

<style lang='scss' scoped>
    @import '~@deanone/dean-components/src/scss/vars';
</style>

